import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=90ff0098&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&scoped=true&lang=js&"
export * from "./PageHeader.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=90ff0098&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ff0098",
  null
  
)

export default component.exports